import React from "react";
import { Form } from "react-bootstrap";

const StatusFilter = ({ setBody, body, statusFilterOptionArr }) => {
  return (
    <li className="d-flex align-items-center gap-10">
      <label htmlFor="" className="form-label m-0 text-muted">
        Filter
      </label>
      <Form.Select
        aria-label="Default select example"
        className=" form-control"
        defaultValue={body.status}
        onChange={(e) =>
          setBody((p) => ({
            ...p,
            status: e.target.value,
          }))
        }
      >
        {statusFilterOptionArr?.map((option) => (
          <option value={option.value}>{option.label}</option>
        ))}
      </Form.Select>
    </li>
  );
};

export default StatusFilter;
